<template>
  <div class="w-full flex flex-col">
    <div class="">
      <div class="mb-4 font-bold text-xl">صورتحساب و پرداخت</div>
    </div>
    <div class="my-10 flex flex-col laptop:flex-row justify-between gap-10">
      <div
        class="flex-grow bg-white rounded-md !rounded-b-none -none border border-blue-700 mb-10 laptop:mb-0"
      >
        <table
          class="w-full h-full [&>thead>td]:text-center [&>tbody>tr>td>*]:mx-auto [&>tbody>tr>td]:text-center"
        >
          <thead
            class="border-b font-semibold border-blue-700 text-xs laptop:text-base [&>td]:p-2"
          >
            <td>محصولات خریداری شده</td>
            <td>تعداد</td>
            <td>قیمت واحد (ریال)</td>
            <td>قیمت کل (ریال)</td>
            <td class="hidden mobile-l:block">ویرایش</td>
          </thead>
          <tbody
            class="[&>tr>td]:py-2 [&>tr>td]:px-1 [&>tr>td]:laptop:p-2 font-normal text-xxs laptop:text-sm"
          >
            <tr v-for="(row, index) in rows" :key="row.id">
              <td>{{ row.name }}</td>
              <td>{{ row.count }}</td>
              <td>{{ row.unitPrice }}</td>
              <td>{{ row.totalPrice }}</td>
              <td
                class="cursor-pointer hidden mobile-l:block"
                @click="changeStep(index)"
              >
                <IconEdit />
              </td>
            </tr>
          </tbody>
        </table>
        <div class="relative my-10 laptop:mt-0">
          <div
            class="absolute flex left-[-1px] mr-[-1px] border laptop:border-t border-blue-700 !rounded-b-md"
          >
            <div
              class="min-w-[70%] laptop:min-w-[200px] text-center text-primary-700"
            >
              <input
                v-model="discountCode"
                type="text"
                class="w-full h-full rounded-br-md text-center"
                :id="Math.random()"
                autocomplete="off"
                placeholder="کد تخفیف"
              />
              <div class="text-red-500 text-xs mt-1 ms-1 font-bold">
                <p v-text="offCodeError" class="font-12 text-center" />
              </div>
            </div>
            <div
              class="px-4 py-2 min-w-[30%] laptop:min-w-[100px] text-center bg-blue-500 text-white select-none cursor-pointer"
              @click="handleSubmit"
              id="oshop-offCode"
            >
              اعمال
            </div>
          </div>
        </div>
      </div>

      <div
        class="w-full laptop:w-[300px] bg-white flex flex-col justify-between rounded-md overflow-hidden border border-blue-700"
      >
        <div class="font-bold border-b border-blue-700 p-2 text-center">
          خلاصه سفارش
        </div>
        <div class="p-6 font-normal">
          <div class="flex justify-between">
            <div>مبلغ خرید:</div>
            <div>{{ totalPrice }} ریال</div>
          </div>
          <div v-if="totalDiscount != '0'" class="flex justify-between">
            <div>تخفیف:</div>
            <div>{{ totalDiscount }} ریال</div>
          </div>
          <div class="flex justify-between">
            <div>مالیات:</div>
            <div>{{ totalVat }} ریال</div>
          </div>
          <div class="font-bold mt-6 text-center">
            <div>مبلغ قابل پرداخت:</div>
            <div>{{ totalFactorPrice }} ریال</div>
          </div>
        </div>
        <div
          class="p-2 bg-blue-700 text-center text-white text-sm cursor-pointer"
          @click="gatewayInfo"
          id="oshop-goGatewy"
          :class="loading ? 'cursor-wait' : ''"
        >
          انتقال به درگاه پرداخت
        </div>
      </div>
    </div>
    <div>
      <div
        class="flex mt-10 flex-col laptop:flex-row [&>*]:mb-4 [&>*]:laptop:mb-0"
      >
        <div class="w-full laptop:max-w-[20%]">
          <BaseButton
            styleType="secondary"
            isLean
            size="full"
            text="بازگشت به مرحله قبل"
            @click="goToPrevStep"
          >
            <IconArrowLeft class="ml-2 rotate-180 my-auto" />
          </BaseButton>
        </div>
      </div>
    </div>
    <SectionModalOPG
      :isShow="isOPGModalShowed"
      @close="isOPGModalShowed = false"
      @select="goToGetway"
    />
  </div>
</template>

<script setup>
const { showConditionFactor, paymentGatewayInfo, applyDiscountCode } =
  useOnlineShopping();
const { fa2en } = useInputHelpers();

const isOPGModalShowed = ref(false);

const emit = defineEmits(["goToPrevStep", "goToStep2"]);
const goToPrevStep = () => {
  emit("goToPrevStep");
};
const changeStep = (index) => {
  if (index && index != 2) {
    emit("goToPrevStep");
  } else {
    emit("goToStep2");
  }
};

onMounted(() => {
  let token = useState("token").value;
  if (!token) {
    const shoppingData = JSON.parse(localStorage.getItem("shoppingData"));
    if (shoppingData) {
      useState("token").value = shoppingData.token;
      useState("InitialCredit").value = shoppingData.InitialCredit;
      useState("ChannelQuantity").value = shoppingData.ChannelQuantity;
      useState("didNo").value = shoppingData.didNo;
      useState("selectDidNoColor").value = shoppingData.selectDidNoColor;
      useState("selectDidNo").value = shoppingData.selectDidNo;
    }
  }
  factorInfo();
});

const totalPrice = ref(null);
const totalVat = ref(null);
const totalFactorPrice = ref(null);
const totalDiscount = ref(null);

const rows = ref([]);

const paymentInfo = ref();

const discountCode = ref();
const offCodeError = ref("");

const loading = ref(false);

const factorInfo = async () => {
  const { data, error } = await showConditionFactor({
    body: {
      campaignName: "OnlineSell",
      type: useState("selectedNumberType").value,
    },
  });
  if (!error.value && data.value) {
    // const jsonData = JSON.parse(data.value.replace(/\\*/g, ""));
    const jsonData = toRaw(data.value);
    totalPrice.value = (+jsonData.totalPrice * 10).toLocaleString();
    totalVat.value = (+jsonData.totalVat * 10).toLocaleString();
    totalFactorPrice.value = (+jsonData.totalFactorPrice * 10).toLocaleString();
    totalDiscount.value = (+jsonData.totalDiscount * 10).toLocaleString();
    rows.value = jsonData.factorDetails.map((el) => {
      return {
        id: String(el.id),
        name: el.title,
        count: (+el.quantity).toLocaleString(),
        unitPrice: (+el.unitPrice * 10).toLocaleString(),
        totalPrice: (+el.totalPrice * 10).toLocaleString(),
      };
    });
  }
};

const gatewayInfo = async () => {
  loading.value = true;
  const { data, error } = await paymentGatewayInfo({ body: {} });
  if (!error.value) {
    // const jsonData = JSON.parse(data.value.replace(/\\*/g, ""));
    const jsonData = toRaw(data.value);
    paymentInfo.value = {
      ResNum: jsonData.resNum,
      RedirectURL: jsonData.redirectUrl,
      Amount: jsonData.amount,
      language: jsonData.language,
      ext: jsonData.ext,
    };
    isOPGModalShowed.value = true;
  }
  loading.value = false;
};

const goToGetway = (url) => {
  let formElement = document.createElement("form");
  formElement.setAttribute("method", "post");
  formElement.setAttribute("action", url);
  for (let param in paymentInfo.value) {
    let hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", param);
    hiddenField.setAttribute("id", param);
    hiddenField.setAttribute("value", paymentInfo.value[param]);
    formElement.appendChild(hiddenField);
  }
  document.body.appendChild(formElement);
  formElement.submit();
};

const handleSubmit = async () => {
  const { data, error } = await applyDiscountCode({
    body: { DiscountCode: fa2en(discountCode.value) },
  });
  // const jsonData = JSON.parse(data.value.replace(/\\*/g, ""));
  const jsonData = toRaw(data.value);
  if (error.value || (jsonData.msg && jsonData.msg != 1)) {
    offCodeError.value = "کد تخفیف وارد شده معتبر نیست.";
    factorInfo();
  } else if (!error.value && jsonData.factorDetails) {
    offCodeError.value = "";
    totalPrice.value = (+jsonData.totalPrice * 10).toLocaleString();
    totalVat.value = (+jsonData.totalVat * 10).toLocaleString();
    totalFactorPrice.value = (+jsonData.totalFactorPrice * 10).toLocaleString();
    totalDiscount.value = (+jsonData.totalDiscount * 10).toLocaleString();
    rows.value = jsonData.factorDetails.map((el) => {
      return {
        id: String(el.id),
        name: el.title,
        count: (+el.quantity).toLocaleString(),
        unitPrice: (+el.unitPrice * 10).toLocaleString(),
        totalPrice: (+el.totalPrice * 10).toLocaleString(),
      };
    });
  }
};
</script>
